import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { GoalsStore, IAddGoalTask, IMemberGoal, TaskAction } from './types'

// the payload carries only goal_id; both screens render the label, so the
// lookup stays here instead of being duplicated in each of them
const goalNames = [
  'Reduce side effects',
  'Manage my conditions',
  'Simplify my medication regiment',
  'Save money'
]

export const useGoalsStore = create<GoalsStore>()(
  devtools(() => ({
    getMemberGoals: async (userId: number) => {
      try {
        const response = await http.get(`/user/${userId}/goals`)

        if (!response) {
          return null
        }

        const goal = response as IMemberGoal
        return { ...goal, name: goalNames[goal.goal_id - 1] }
      } catch (error) {
        console.error('Error fetching member goals:', error)
        return null
      }
    },

    sendTaskAction: async (
      userId: number,
      taskId: number,
      action: TaskAction
    ) => {
      try {
        await http.post(`/user/${userId}/tasks/${taskId}/action`, { action })

        return true
      } catch (error) {
        console.error('Error sending task action:', error)
        return false
      }
    },

    addGoalTask: async (userId: number, task: IAddGoalTask) => {
      try {
        await http.post(`/user/${userId}/tasks`, { ...task })

        return true
      } catch (error) {
        console.error('Error adding goal task:', error)
        return false
      }
    }
  }))
)
